import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-links',
  templateUrl: './footer-links.component.html',
  styleUrls: ['./footer-links.component.css']
})
export class FooterLinksComponent  { }



// WEBPACK FOOTER //
// ./src/app/structural_components/footer/footer-links/footer-links.component.ts